<template>
    <ToolButton :Editor="Editor" KnownIcon="H6" @ToolClick="Editor.chain().focus().toggleHeading({ level: 6 }).run()"
        :class="{ 'toggled': Editor.isActive('heading', { level: 6 }) }">

    </ToolButton>
</template>
<script>

import ToolButton from '@/views/components/atoms/tiptap/Predefined/Buttons/ToolButton.vue';

export default ({
    components: {
        ToolButton
    },
    props: ["Editor"]
});
</script>